'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { FileDropOverlay } from '#pplx/frontend/apps/ask/composer-sdk-plugins/file-upload/FileDropOverlayComponents.js';
export function renderFileDropOverlay(props, state) {
    return _jsx(FileDropOverlay, { maxFiles: props.maxFiles, ...state });
}
//# sourceMappingURL=FileDropOverlaySupport.js.map